import React from "react";
import { HeroDataInfo } from "../../organisms/HeroDataInfo";
import { Box, Grid, GridItem, IconWarningLight, Tag, Text3, skinVars, useScreenSize } from "@telefonica/mistica";
import { CardWithBorder } from "../../CardWithBorder";
import { Button } from "../../atoms";
import { ScreenResponsive } from "../../ScreenResponsive";
import { observer } from "mobx-react-lite";

interface IProps {
	title: string;
	description: string;
	offers: string;
	tag: string;
	titleCard: string;
	descriptionCard: string;
	buttonTextOnContinue: string;
	buttonTextOnBack: string;
	onRedirect(): void;
	onBack(): void;
}

export const CreditProposal: React.FC<IProps> = observer((props) => {
	const {
		onRedirect,
		onBack,
		title,
		description,
		offers,
		tag,
		titleCard,
		descriptionCard,
		buttonTextOnContinue,
		buttonTextOnBack,
	} = props;
	const { isDesktopOrBigger } = useScreenSize();

	return (
		<ScreenResponsive isFullHeight={isDesktopOrBigger}>
			<Box paddingBottom={isDesktopOrBigger ? 24 : 0}>
				<Box paddingBottom={isDesktopOrBigger ? 80 : 32} paddingTop={isDesktopOrBigger ? 40 : 32}>
					<Grid columns={isDesktopOrBigger ? 4 : 1} justifyContent={"center"}>
						<GridItem columnStart={2} span={isDesktopOrBigger ? 2 : 1}>
							<Box width={isDesktopOrBigger ? 600 : "100%"}>
								<Box paddingBottom={isDesktopOrBigger ? 40 : 32}>
									<HeroDataInfo
										icon={<IconWarningLight size={64} color={skinVars.colors.brand} />}
										title={title}
										description={description}
									/>
								</Box>
								<Grid columns={{ maxSize: 392 }} justifyContent={"center"}>
									<Box paddingBottom={16}>
										<Text3 regular>{offers}</Text3>
									</Box>
									<CardWithBorder
										icon={<Tag type="success">{tag}</Tag>}
										title={titleCard}
										description={descriptionCard}
										button
										textButton={buttonTextOnContinue}
										onPress={onRedirect}
										additionalSpace={isDesktopOrBigger ? true : false}
									/>
									<Box paddingTop={isDesktopOrBigger ? 40 : 32}>
										<Button textButton={buttonTextOnBack} onAction={onBack} />
									</Box>
								</Grid>
							</Box>
						</GridItem>
					</Grid>
				</Box>
			</Box>
		</ScreenResponsive>
	);
});
